import React, { useState, useMemo, useEffect } from "react";
import { DatePicker, Input, Select, Button, Card, Row, Col, Statistic } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import Table from "../components/Table";
import TableInput from "../components/TableInput";
import { useFetchEmployeeCaseReport, useFetchEmployeeCaseReportInput } from "../hooks/useFetch";
const { RangePicker } = DatePicker;
// import { useFetchCase3 } from "../hooks/useFetch";


const EmployeeCaseReportPage = () => {
  const today = dayjs();
  const [selectedDate, setSelectedDate] = useState([today, today]);
  const [selectedDateInput, setSelectedDateInput] = useState([today, today]);
  const { mutateAsync: listEmployeeCaseOutput, isLoading: isLoadingOutput } = useFetchEmployeeCaseReport();
  const { mutateAsync: listEmployeeCaseInput, isLoading: isLoadingInput } = useFetchEmployeeCaseReportInput();
  const [dataOutput, setDataOutput] = useState([]);
  const [dataInput, setDataInput] = useState([]);

  const handleClearFilters = () => {
    setSelectedDate([today, today]);
  };

  const handleClearInputFilters = () => {
    setSelectedDateInput([today, today]);
  };

  const handleSearch = () => {
    let startDate = selectedDate[0].format("YYYY-MM-DD");
    let endDate = selectedDate[1].format("YYYY-MM-DD");
    listEmployeeCaseOutput({
      startDate,
      endDate,
    }).then((res) => {
      setDataOutput(res.result);
    }).catch((err) => {
      console.log(err);
    });
  };

  const handleInputSearch = () => {
    let startDate = selectedDateInput[0].format("YYYY-MM-DD");
    let endDate = selectedDateInput[1].format("YYYY-MM-DD");
    listEmployeeCaseInput({
      startDate,
      endDate,
    }).then((res) => {
      setDataInput(res.result);
    }).catch((err) => {
      console.log(err);
    });
  };

  return (
    <div style={{ padding: 16, background: "#f5f5f5", minHeight: "100vh", marginLeft: 16 }}>
      {/* Title */}
      <div style={{ marginBottom: 20 }}>
        <h1
          style={{
            margin: 0,
            fontSize: "2rem",
            fontWeight: "bold",
            color: "#212121",
            letterSpacing: "0.5px",
            lineHeight: 1.2,
          }}
        >
          รายงานการตรวจสอบเคส (รายบุคคล)
        </h1>
      </div>

      {/* Output Section */}
      <div
        style={{
          background: "#fff",
          borderRadius: 10,
          padding: 20,
          marginBottom: 20,
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        }}
      >
        <h1
          style={{
            margin: 0,
            fontSize: "2rem",
            fontWeight: "bold",
            color: "#212121",
            letterSpacing: "0.5px",
            lineHeight: 1.2,
          }}
        >
          Output
        </h1>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
            gap: 16,
            alignItems: "end",
            marginTop: 20,
          }}
        >
          {/* Date Range Picker */}
          <div style={{ marginBottom: 20 }}>
            {/* <label
              style={{
                display: "block",
                marginBottom: 8,
                fontSize: 14,
                fontWeight: 500,
                color: "#333",
              }}
            >
              วันที่
            </label> */}
            <RangePicker
              value={selectedDate}
              onChange={setSelectedDate}
              format="DD/MM/YYYY"
              style={{ width: "100%" }}
              allowClear={false}
            />
          </div>

          {/* Action Buttons */}
          <div style={{ display: "flex", gap: 8, marginBottom: 20 }}>
            <Button type="primary" onClick={handleSearch}>
              ค้นหา
            </Button>
            <Button onClick={handleClearFilters}>
              ล้างค่า
            </Button>
          </div>
        </div>

        {/* Table Section */}
        <Table
          data={dataOutput}
          loading={isLoadingOutput}
          refetch={handleSearch}
        />
      </div>

      {/* Input Section */}
      <div
        style={{
          background: "#fff",
          borderRadius: 10,
          padding: 20,
          marginBottom: 20,
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        }}
      >
        <h1
          style={{
            margin: 0,
            fontSize: "2rem",
            fontWeight: "bold",
            color: "#212121",
            letterSpacing: "0.5px",
            lineHeight: 1.2,
          }}
        >
          Input
        </h1>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
            gap: 16,
            alignItems: "end",
            marginTop: 20,
          }}
        >
          {/* Date Range Picker */}
          <div style={{ marginBottom: 20 }}>
            <RangePicker
              value={selectedDateInput}
              onChange={setSelectedDateInput}
              format="DD/MM/YYYY"
              style={{ width: "100%" }}
              allowClear={false}
            />
          </div>

          {/* Action Buttons */}
          <div style={{ display: "flex", gap: 8, marginBottom: 20 }}>
            <Button type="primary" onClick={handleInputSearch}>
              ค้นหา
            </Button>
            <Button onClick={handleClearInputFilters}>
              ล้างค่า
            </Button>
          </div>
        </div>

        {/* Table Section */}
        <TableInput
          data={dataInput}
          loading={isLoadingInput}
          refetch={handleInputSearch}
        />
      </div>
    </div>
  );
};

export default EmployeeCaseReportPage;

